module.exports = __webpack_public_path__ + "img/blog.3f7dbc26.jpg";